/* eslint-disable */

import './instrument';
import { Suspense, useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useLocation, useSearchParams } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import NetworkChecker from './utils/networkChecker'; // แก้ path ตามจริง
import { MessageProvider } from './context/MessageContext';
import { useCookies } from 'react-cookie';
import { useMsal } from '@azure/msal-react';
import {
  cookieExpiryDays,
  exchangeSessionToken,
  needsMsExchange,
  resolveMsTokenForExchange,
} from './sections/employee/utils/exchangeSession';
import { Sentry } from './instrument';

import App from './app';
import { DataProvider } from './context/index';
import { startAppBuildCheck } from './utils/checkAppBuild';
import PasswordExpiryGate from './sections/login/password-expiry-gate';
import PinRequiredGate from './sections/login/pin-required-gate';

function InactivityHandler() {
  useEffect(() => {
    let timeout;
    const TIMEOUT_MINUTES = 15;
    const resetTimeout = () => {
      clearTimeout(timeout);
      timeout = setTimeout(
        () => {
          if (window.confirm('คุณไม่ได้ใช้งานมานานกว่า 15 นาที ต้องการโหลดหน้าใหม่หรือไม่?')) {
            window.location.reload();
          }
        },
        TIMEOUT_MINUTES * 60 * 1000
      );
    };

    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

    events.forEach((event) => window.addEventListener(event, resetTimeout));
    resetTimeout();

    return () => {
      clearTimeout(timeout);
      events.forEach((event) => window.removeEventListener(event, resetTimeout));
    };
  }, []);

  return null;
}
function SsoHandler() {
  const [, setCookie] = useCookies(['session']);
  const [searchParams, setSearchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const ssoCode = searchParams.get('sso');

  useEffect(() => {
    if (!ssoCode) return;
    setLoading(true);

    fetch('https://api-hr.boonsiri.co.th/verifySsoCode', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ code: ssoCode }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.status === 'success' && data.token) {
          const exp = new Date();
          exp.setDate(exp.getDate() + 7);
          setCookie('session', data.token, { path: '/', expires: exp });
        }
        // ลบ sso param จาก URL
        searchParams.delete('sso');
        setSearchParams(searchParams, { replace: true });
        window.location.reload();
      })
      .catch(() => {
        searchParams.delete('sso');
        setSearchParams(searchParams, { replace: true });
        setLoading(false);
      });
  }, [ssoCode]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'Prompt, sans-serif', color: '#64748b' }}>
        กำลังเข้าสู่ระบบผ่าน BSR One Auth...
      </div>
    );
  }

  return null;
}

function SessionBootstrap() {
  const { instance, accounts } = useMsal();
  const [cookies, setCookie] = useCookies(['session']);
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === '/forgotPassword') return;
    const account = instance.getActiveAccount() || accounts[0];
    if (!needsMsExchange(cookies.session) || !account) return;

    let cancelled = false;
    (async () => {
      const msToken = await resolveMsTokenForExchange(
        instance,
        account,
        cookies.session
      );
      if (!msToken || cancelled) return;

      const json = await exchangeSessionToken(msToken);
      if (cancelled || json.resCode !== '0000' || !json.token) return;

      setCookie('session', json.token, {
        path: '/',
        expires: cookieExpiryDays(30),
      });
    })().catch(console.error);

    return () => {
      cancelled = true;
    };
  }, [pathname, cookies.session, accounts[0]?.homeAccountId, instance, setCookie]);

  return null;
}

const msalInstance = new PublicClientApplication(msalConfig);

// ----------------------------------------------------------------------

startAppBuildCheck();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  /* eslint-disable */
  <Sentry.ErrorBoundary
    fallback={
      <div style={{ padding: 24, fontFamily: 'Noto Sans Thai, sans-serif', textAlign: 'center' }}>
        เกิดข้อผิดพลาด กรุณารีเฟรชหน้าเว็บ
      </div>
    }
  >
    <DataProvider>
      <HelmetProvider>
        <BrowserRouter>
          <SsoHandler />
          <PasswordExpiryGate />
          <PinRequiredGate />
          <Suspense>
            <MsalProvider instance={msalInstance}>
              <SessionBootstrap />
              <InactivityHandler />
              <NetworkChecker />
              <MessageProvider>
                <App />
              </MessageProvider>
            </MsalProvider>{' '}
          </Suspense>
        </BrowserRouter>
      </HelmetProvider>
    </DataProvider>
  </Sentry.ErrorBoundary>
  /* eslint-disable */
);
